import React, { useEffect } from 'react';

import { Typography } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import { Page } from '../components';
import { useTranslation } from 'react-i18next';
import * as userApi from '../api/user-api';

function EmailVerifiedPage() {
  const { t } = useTranslation();
  const handleUpdateCountryCode = async (countryCode) => {
    const ud = (await userApi.getData())[0];
    ud.countryCode = countryCode;
    await userApi.setData(ud);
    window.location.reload();
  };

  useEffect(() => {
    const pendingRegData = JSON.parse(localStorage.getItem('pendingRegData'));
    if (pendingRegData) {
      localStorage.removeItem('pendingRegData');
      const { email, password, countryCode } = pendingRegData;
      userApi.login(email, password).then(() => {
        handleUpdateCountryCode(countryCode);
      });
    }
  }, []);
  function render({ isLoggedIn }) {
    return isLoggedIn ? (
      <Redirect to="/search" />
    ) : (
      <Typography variant="h6">{t('email_verified')}</Typography>
    );
  }

  return <Page render={render} />;
}

export default EmailVerifiedPage;
